import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import FixedWidthContainer from 'components/consumer/FixedWidthContainer';
import SuspenseWithLoader from 'components/consumer/SuspenseWithLoader';
import JBImage from 'components/essentials/JBImage';
import useIsBrowser from 'hooks/useIsBrowser';
import usePDPBasicDetails from 'components/consumer/PDP/state/context/usePDPBasicDetails';
import usePdpShowStickyButtons from '../state/context/usePdpShowStickyButtons';
import PDPAddToBagSection from '../PDPAddToBagSection';
import PDPPriceSection from '../PDPPriceSection';
import PDPLeadTimeUI from '../PDPNameSection/PDPLeadTimeUI';
import PDPStickySummaryOptions from './PDPStickySummaryOptions';

// Stands in for the sticky price row PDPNameSection turns off in the layout revamp
const PDPStickySummaryBarInner = t0 => {
  const $ = _c(26);
  const {
    slug,
    productCylindoHeroImage: t1
  } = t0;
  const productCylindoHeroImage = t1 === undefined ? null : t1;
  const isBrowser = useIsBrowser();
  const showStickyButtons = usePdpShowStickyButtons();
  const {
    data: basicDetails
  } = usePDPBasicDetails();
  const heroSrc = basicDetails?.hero_images?.[0]?.img?.url;
  const cylindoSrc = productCylindoHeroImage?.src;
  const t2 = !showStickyButtons;
  let t3;
  if ($[0] !== showStickyButtons || $[1] !== t2) {
    t3 = classNames("fixed inset-x-0 top-0 z-[999] bg-white shadow-md transition-[opacity,visibility] ease-in max-[1023px]:hidden", {
      "opacity-0 invisible pointer-events-none": t2,
      "opacity-100": showStickyButtons
    });
    $[0] = showStickyButtons;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== cylindoSrc || $[4] !== heroSrc) {
    t4 = cylindoSrc ? <img src={cylindoSrc} alt="" width="112" height="75" className="h-[75px] w-[112px] object-contain flex-none" /> : heroSrc && <JBImage src={heroSrc} width="112" height="75" className="h-[75px] w-[112px] object-contain flex-none" />;
    $[3] = cylindoSrc;
    $[4] = heroSrc;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = basicDetails?.name;
  let t6;
  if ($[6] !== t5) {
    t6 = <div className="text-base font-bold text-gray">{t5}</div>;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <PDPPriceSection />;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t6) {
    t8 = <div className="flex-none">{t6}{t7}</div>;
    $[9] = t6;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== slug) {
    t9 = <PDPStickySummaryOptions slug={slug} className="border-0 border-l border-solid border-gray-light6 pl-8" />;
    $[11] = slug;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <PDPAddToBagSection stickyDesktopButtonOnly={true} keepAddToBagLabel={true} />;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== isBrowser) {
    t11 = isBrowser && <PDPLeadTimeUI mode="pdp" />;
    $[14] = isBrowser;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== t11) {
    t12 = <div className="ml-auto w-[400px] flex-none text-center">{t10}{t11}</div>;
    $[16] = t11;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== t12 || $[19] !== t4 || $[20] !== t8 || $[21] !== t9) {
    t13 = <FixedWidthContainer wide={true} className="flex items-center gap-8 !py-3">{t4}{t8}{t9}{t12}</FixedWidthContainer>;
    $[18] = t12;
    $[19] = t4;
    $[20] = t8;
    $[21] = t9;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== t13 || $[24] !== t3) {
    t14 = <div data-xc="PDPStickySummaryBar" className={t3}>{t13}</div>;
    $[23] = t13;
    $[24] = t3;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  return t14;
};
PDPStickySummaryBarInner.propTypes = {
  slug: PropTypes.string,
  productCylindoHeroImage: PropTypes.shape({
    src: PropTypes.string.isRequired
  })
};

// Null fallback: a loader here would sit in normal flow and push the page down
const PDPStickySummaryBar = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <SuspenseWithLoader fallback={null}><PDPStickySummaryBarInner {...props} /></SuspenseWithLoader>;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export default PDPStickySummaryBar;